import { useCallback, useState } from 'react'

import { IProductCard } from '@src/components/product-card/product-card.types'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { RECOMMENDED_SECTION_IDS } from '@src/quince-site-pdp/src/contexts/productPageContext.constants'

import {
  NEW_RECOMMENDED_SECTION_LIMIT_UI,
  NEW_RECOMMENDED_SECTION_LIMIT_UI_MOBILE,
  transformedRecommendationData,
} from '../contexts/product.helpers'
import { productContextInitialState } from '../contexts/ProductPageContext'

const useRecommendation = (productPageExpData: any) => {
  const initialRecommendationUIData = productContextInitialState.recommendationUIData
  const [recommendationQuinceAPIData, setQuinceRecommendationAPIData] = useState<
    Record<string, Record<string, IProductCard[] | string>>
  >(productContextInitialState.recommendationUIData)
  const deviceInfo = useDeviceInfo()
  const isDesktop = deviceInfo.deviceType === DEVICE_TYPES.DESKTOP

  //Quince recommendation flow
  const updateRecommendationAPIData = useCallback(
    (sectionKey: RECOMMENDED_SECTION_IDS, sectionValue: Record<string, IProductCard[] | string>) => {
      if (sectionValue) {
        setQuinceRecommendationAPIData(prevData => ({ ...prevData, [sectionKey]: sectionValue }))
      }
    },
    [],
  )
  const recommendedSectionLimitForNewPDP = isDesktop
    ? NEW_RECOMMENDED_SECTION_LIMIT_UI
    : NEW_RECOMMENDED_SECTION_LIMIT_UI_MOBILE

  const transformedUIData = transformedRecommendationData(
    recommendationQuinceAPIData,
    productPageExpData?.recommendedSectionPriorityArray,
    productPageExpData?.recommendationSectionLimit || recommendedSectionLimitForNewPDP,
  )

  return {
    recommendationUIData: transformedUIData || initialRecommendationUIData,
    updateRecommendationAPIData,
    isRecommendationLoading: false,
  }
}

export default useRecommendation
